const FAQ_TABS_SELECTOR = "[data-faq-tabs]";
function initFaqTabsRoot(root) {
  if (!(root instanceof HTMLElement) || root.dataset.faqTabsInit === "1")
    return;

  const tabs = [...root.querySelectorAll('.faq-tabs__tablist [role="tab"]')];
  const panels = [
    ...root.querySelectorAll('.faq-tabs__panels [role="tabpanel"]'),
  ];
  if (!tabs.length || tabs.length !== panels.length) return;

  const syncTabLabelsFromPanels = () => {
    tabs.forEach((tab, i) => {
      const panel = panels[i];
      if (!panel) return;
      const label = panel.getAttribute("data-tab-label");
      if (label != null && label !== "") tab.textContent = label;
    });
  };
  syncTabLabelsFromPanels();

  root.dataset.faqTabsInit = "1";

  const select = (index) => {
    const i = Math.max(0, Math.min(index, tabs.length - 1));
    tabs.forEach((tab, j) => {
      const on = j === i;
      tab.setAttribute("aria-selected", on ? "true" : "false");
      tab.tabIndex = on ? 0 : -1;
      panels[j].hidden = !on;
    });
  };

  tabs.forEach((tab, i) => {
    tab.addEventListener("click", () => select(i));
    tab.addEventListener("keydown", (e) => {
      const last = tabs.length - 1;
      if (e.key === "ArrowRight" || e.key === "ArrowDown") {
        e.preventDefault();
        const next = i === last ? 0 : i + 1;
        select(next);
        tabs[next].focus();
      } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
        e.preventDefault();
        const prev = i === 0 ? last : i - 1;
        select(prev);
        tabs[prev].focus();
      } else if (e.key === "Home") {
        e.preventDefault();
        select(0);
        tabs[0].focus();
      } else if (e.key === "End") {
        e.preventDefault();
        select(last);
        tabs[last].focus();
      }
    });
  });
}

function initAllFaqTabsIn(container) {
  const el = container instanceof HTMLElement ? container : document;
  el.querySelectorAll(FAQ_TABS_SELECTOR).forEach(initFaqTabsRoot);
}

document.addEventListener("DOMContentLoaded", () => initAllFaqTabsIn(document));

document.addEventListener("shopify:section:load", (event) => {
  if (!(event.target instanceof HTMLElement)) return;
  event.target.querySelectorAll(FAQ_TABS_SELECTOR).forEach((root) => {
    delete root.dataset.faqTabsInit;
  });
  initAllFaqTabsIn(event.target);
});
